import axios from 'axios'

import config from '../../config'

const updateSafetyItemResponse = (params = {}, data) => {
  const { airportId } = params

  const url = `${config.baseUrl}/${airportId}/SafetyItemResponses`
  return axios.put(url, data)
}

export default updateSafetyItemResponse
